export default __webpack_public_path__ + "static/media/automated-invoice-management-vegshelf-marketplace.2a40df39.png";